import { useEffect, useState } from 'react'
import { useAuthStore } from 'src/store/auth'
import { Card, Space } from 'antd';

import './Policy.css'

export const Policy = () => {
  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  useEffect(() => {
    setActiveKeyMainMenu('')
  }, [setActiveKeyMainMenu])

  return (
    <div className='policy-wrapper' style={{ display: 'flex', justifyContent: 'center' }}>
      <Card className='policy-card' style={{ maxWidth: 700 }}>
        <h1>Privacy Policy</h1>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>
            Engagement de Confidentialité pour l'Application de Vente de
            Brocante
          </span>
        </p>
        <p className='normal0'>
          <span>
            Cet Engagement de Confidentialité ("l'Engagement") est conclu entre
            PICnFIND SAS, ayant son siège social au 31, avenue Hoche, 75008
            Paris, ci-après dénommé "le Développeur", et les utilisateurs de
            l'application de vente de brocante intitulée PICnFIND, disponible
            sur la plateforme Apple App Store, ci-après dénommée
            "l'Application". L'Application est conçue pour faciliter la vente de
            biens d'occasion entre utilisateurs.
          </span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>
            1. Collecte de Données Personnelles
          </span>
        </p>
        <p className='normal0'>
          <span>
            Le Développeur s'engage à collecter et à utiliser les données
            personnelles des utilisateurs de l'Application de manière
            responsable et conforme à la législation en vigueur. Les données
            personnelles peuvent inclure, sans s'y limiter, les noms, les
            adresses e-mail, les numéros de téléphone, les adresses postales,
            les informations de paiement, les photos de profil et d'autres
            informations pertinentes.
          </span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>2. Utilisation des Données</span>
        </p>
        <p className='normal0'>
          <span>
            Le Développeur collecte des données personnelles dans le but de
            fournir des services liés à l'Application, notamment la création de
            comptes utilisateur, la gestion des transactions, la communication
            entre les utilisateurs, l'amélioration de l'expérience de
            l'Application et la conformité aux exigences légales. Les données
            personnelles ne seront pas vendues, louées ou partagées avec des
            tiers non autorisés.
          </span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>
            3. Confidentialité et Sécurité
          </span>
        </p>
        <p className='normal0'>
          <span>
            Le Développeur prend des mesures de sécurité appropriées pour
            protéger les données personnelles des utilisateurs contre tout accès
            non autorisé, la divulgation, la modification ou la destruction.
            Cependant, l'utilisateur reconnaît que la sécurité des données ne
            peut jamais être garantie à 100 %.
          </span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>
            4. Durée de Conservation des Données
          </span>
        </p>
        <p className='normal0'>
          <span>
            Le Développeur conservera les données personnelles des utilisateurs
            aussi longtemps que nécessaire pour atteindre les objectifs définis
            dans cet Engagement ou conformément à la législation applicable. Les
            utilisateurs ont le droit de demander la suppression de leurs
            données personnelles à tout moment.
          </span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>5. Droits des Utilisateurs</span>
        </p>
        <p className='normal0'>
          <span>
            Les utilisateurs ont le droit d'accéder à leurs données
            personnelles, de les corriger, de les supprimer ou de s'opposer à
            leur traitement. Pour exercer ces droits, les utilisateurs peuvent
            contacter le Développeur à l'adresse e-mail{' '}
          </span>
          <a
            href='mailto:contact@picnfind.com'
            style={{ textDecoration: 'none' }}
          >
            <span style={{ textDecoration: 'none', color: '#1155cc' }}>
              contact@picnfind.com
            </span>
          </a>
          <span>.</span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>
            6. Modifications de la Politique de Confidentialité
          </span>
        </p>
        <p className='normal0'>
          <span>
            Le Développeur se réserve le droit de modifier cet Engagement de
            Confidentialité à tout moment. Les modifications seront signalées
            aux utilisateurs par le biais de l'Application ou par d'autres
            moyens appropriés. L'utilisation continue de l'Application après de
            telles modifications constitue l'acceptation de ces changements.
          </span>
        </p>
        <p className='normal0' style={{ paddingTop: 20, paddingBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>7. Contact</span>
        </p>
        <p className='normal0'>
          <span>
            Pour toute question ou préoccupation concernant cet Engagement de
            Confidentialité ou la collecte et l'utilisation des données
            personnelles par l'Application, veuillez contacter le Développeur à
            l'adresse suivante : contact@picnfind.com.
          </span>
        </p>
        <p className='normal0'>
          <span>
            En utilisant l'Application, les utilisateurs acceptent les termes et
            conditions de cet Engagement de Confidentialité.
          </span>
        </p>
        <p className='normal0'>
          <span>Fait le 29/09/2023.</span>
        </p>
        <p className='normal0'>
          <span>PICnFIND SAS.</span>
        </p>
      </Card>
    </div>
  )
}
